module.exports = __webpack_public_path__ + "img/didattica_inclusiva.5c762623.svg";